import React from 'react'
import PropTypes from 'prop-types'

import failureSvg from '../../../../public/images/icons/alert-modal-failure.svg'

const propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired
}

export const FailureToast = ({ heading, body }) => (
  <div className="toast-alert__body">
    <img className="svg" src={failureSvg} alt="failure" />
    <h2>{heading}</h2>
    <p
      dangerouslySetInnerHTML={{
        __html: body
      }}
    />
  </div>
)
FailureToast.propTypes = propTypes
